import React, { useCallback, useEffect, useState } from 'react';

import { pausedInvoiceIcon } from '@europrocurement/l2d-icons';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router';
import {
    factureAchatsFiltersToElasticQuery,
    useAchatsService,
    useSociete,
} from '@europrocurement/l2d-domain';
import achatsViewPathResolver from '../../../../Achats/achatsViewPathResolver';
import WidgetWithAction from './components/WidgetWithAction';

// All

const FacturesEnPause: React.FunctionComponent = function () {
    const navigate = useNavigate();
    const xIdSociete = useSociete();

    const { factureAchatApi } = useAchatsService();

    const [countOfInvoicesResumed, setCountOfInvoicesResumed] = useState<string>();

    useEffect(() => {
        factureAchatApi
            .getFacturesAchatsFactureAchatCollection(
                factureAchatsFiltersToElasticQuery({
                    xIdSociete,
                    search: '',
                    orders: [],
                    pagination: {
                        page: 0,
                        itemsPerPage: 0,
                    },
                    filters: {
                        cloture: false,
                        deleted: false,
                    },
                }),
            )
            .then((res) => {
                if (
                    res.data['hydra:totalItems'] !== null ||
                    res.data['hydra:totalItems'] !== undefined
                ) {
                    setCountOfInvoicesResumed(`${res.data['hydra:totalItems']}`);
                }
            });
    }, [factureAchatApi, xIdSociete]);

    const actionCallback = useCallback(async () => {
        navigate(achatsViewPathResolver('listfacturepause'));
    }, [navigate]);

    return (
        <Grid
            sx={{
                flex: 1,
            }}
            item
            lg={1}
            md={1}
            xs={12}
        >
            <WidgetWithAction
                title="Factures en pause"
                icon={pausedInvoiceIcon}
                actionMessage="Traiter"
                actionCallback={actionCallback}
                data={countOfInvoicesResumed}
                paragraph="Factures en pause :"
                color="warning"
            />
        </Grid>
    );
};

export default FacturesEnPause;
